import { requestApi } from "./api";

export interface MemberSessionResult {
  token: string;
  expiresAt: string;
  member: {
    memberCode: string;
    loginId: string | null;
    name: string;
    email: string;
    phone: string | null;
  };
  profileRequired: boolean;
  accountInfoRequired?: boolean;
}

export type KakaoLoginResult = MemberSessionResult;

export function getKakaoAuthorizeUrl() {
  return requestApi<{ authorizeUrl: string }>("/auth/kakao/authorize-url");
}

export function loginWithKakao(code: string) {
  return requestApi<KakaoLoginResult>("/auth/kakao/login", {
    method: "POST",
    body: JSON.stringify({ code })
  });
}

export function checkLoginId(loginId: string) {
  return requestApi<{ available: boolean }>(`/auth/email/check-id?loginId=${encodeURIComponent(loginId)}`);
}

export function sendEmailVerification(email: string, purpose: "SIGNUP" | "FIND_ID" | "RESET_PASSWORD") {
  return requestApi<{ email: string; expiresAt: string; resendAfterSeconds: number }>("/auth/email/send", {
    method: "POST",
    body: JSON.stringify({ email, purpose })
  });
}

export function verifyEmailCode(email: string, purpose: "SIGNUP" | "FIND_ID" | "RESET_PASSWORD", code: string) {
  return requestApi<{ email: string; verified: boolean }>("/auth/email/verify", {
    method: "POST",
    body: JSON.stringify({ email, purpose, code })
  });
}

export function signupWithEmail(payload: { loginId: string; password: string; name: string; phone: string; email: string }) {
  return requestApi<MemberSessionResult>("/auth/email/signup", {
    method: "POST",
    body: JSON.stringify(payload)
  });
}

export function loginWithEmail(loginId: string, password: string) {
  return requestApi<MemberSessionResult>("/auth/email/login", {
    method: "POST",
    body: JSON.stringify({ loginId, password })
  });
}

export function findLoginId(email: string) {
  return requestApi<{ loginId: string }>(`/auth/email/find-id?email=${encodeURIComponent(email)}`);
}

export function resetPassword(email: string, password: string) {
  return requestApi<{ updated: boolean }>("/auth/email/reset-password", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}
